import jMoment from 'moment-jalaali';
import { FILTER_TYPES } from 'components/FilterPod';

const filters = (accountOptions = []) => [
  {
    title: 'محدوده تاریخ صدور',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(30, 'days'),
      end: jMoment(new Date().setHours(23, 59, 0, 0)),
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
    disableDelete: true,
  },
  {
    title: 'شماره سند',
    label: 'شماره سند',
    keyName: 'docId',
    id: 7075,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: { dir: 'ltr', englishNumber: true },
  },
];

export default filters;

const WITHDRAWAL_DEPOSIT = [
  {
    label: 'واریز',
    value: '1',
  },
  {
    label: 'برداشت',
    value: '0',
  },
];

const TRANSACTION_TYPES = [
  {
    label: 'انتقال اعتبار از کسب‌وکار',
    value: '70368744177664',
  },
  {
    label: 'انتقال وجه بین حساب های کاربر',
    value: '18014398509481984',
  },
  {
    label: 'کارمزد درخواست تسویه حساب مشتری',
    value: '576460752303423488',
  },
  {
    // 2
    label: 'انتقال وجه بین حساب های کاربر2',
    value: '134217728',
  },
  {
    label: 'افزایش اعتبار کاربر',
    value: '16384',
  },
  {
    label: 'خرید کالا از طریق فاکتور',
    value: '68719476736',
  },
  {
    label: 'مسدودی',
    value: '144115188075855872',
  },
  {
    label: 'پرداخت',
    value: '17179869184',
  },
  {
    label: 'پرداخت وجه چک',
    value: '72057594037927936',
  },
  {
    label: 'انتقال اعتبار به مخاطب',
    value: '2251799813685248',
  },
  {
    label: 'انتقال اعتبار به کاربر از طرف کاربر',
    value: '4503599627370496',
  },
  {
    label: 'اعطای تسهیلات',
    value: '137438953472',
  },
  {
    label: 'درخواست تسویه حساب',
    value: '65536',
  },
  {
    label: 'برگشتی',
    value: '1152921504606846976 ',
  },
  {
    label: 'افزایش اعتبار توسط سیستم برای کاربر',
    value: '1125899906842624',
  },
  {
    label: 'افزایش اعتبار از طریق بن افزایش اعتبار',
    value: '562949953421312',
  },
  {
    label: 'سایر',
    value: '158456325028528675187087900672',
  },
];

const STATUS_OPTIONS = [
  {
    label: 'لغو شده قبل از پرداخت',
    value: 'لغو شده قبل از پرداخت',
  },
  {
    label: 'مسترد شده',
    value: 'مسترد شده',
  },

  {
    label: 'پرداخت شده',
    value: 'پرداخت شده',
  },
  {
    label: 'پرداخت نشده',
    value: 'پرداخت نشده',
  },
  {
    label: 'بسته شده',
    value: 'بسته شده',
  },
];
